import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { FC, useRef } from 'react'
import { ImageCarousel } from '../../../../../components/organisms/image-carousel'
import { SIZES } from '@dtx-company/true-common/src/constants/mediaQueries'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { WaysToUseCarouselData } from '../types'
import { useMediaQuery } from '@dtx-company/shared-components/src/utils'
import { useVisibilityThreshold } from '../../../../../hooks/useVisibilityThreshold'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'

//sectionId is used for navigation
const WaysToUseCarouselSection: FC<{ data?: WaysToUseCarouselData; sectionId?: string }> = ({
  data,
  sectionId
}) => {
  const isTablet = useMediaQuery(SIZES.desktop - 1)
  const isMobile = useMediaQuery(SIZES.mobile)
  const waysToUseSectionRef = useRef<HTMLDivElement | null>(null)
  const { visible } = useVisibilityThreshold({ threshold: 0.1, ref: waysToUseSectionRef })

  if (!data) return null
  const images =
    data.items?.map(({ image }) => {
      return {
        src: image.url ?? '',
        alt: image.alt ?? '',
        slideWrapperProps: {
          width: { _: '230px', md: '240px', lg: '250px' },
          mx: '6px'
        }
      }
    }) ?? []

  let numOfSlides = 4 // 4 slides in Desktop
  if (isMobile) numOfSlides = 2
  else if (isTablet) numOfSlides = 3

  return (
    <Box display="block" ref={waysToUseSectionRef} id={sectionId} marginTop={4}>
      <PrismicText
        richTextField={data.primary?.header}
        fontSize={{ _: '24px', md: '28px', lg: '32px' }}
        lineHeight={{ _: '30px', lg: '40px' }}
        variant={'display/large'}
        px={['40px', '75px', null, '143px']}
        maxWidth="866px"
        mx="auto"
        textAlign="center"
      />
      <Spacer mb="8px" />
      <PrismicText
        richTextField={data.primary?.subheader}
        fontSize={['14px', '16px', '20px']}
        lineHeight={['16.94px', '19.36px', '24px']}
        variant={'body/large'}
        px={['40px', '75px', null, '143px']}
        maxWidth="866px"
        mx="auto"
        textAlign="center"
      />
      {/*Images are optional*/}
      {images && images.length > 0 && (
        <>
          <Spacer mb={{ _: '16px', lg: '52px' }} />
          <ImageCarousel
            images={images}
            scrollable={true}
            nVisibleSlides={numOfSlides}
            maxWidth={{ _: '100%', md: '750px', lg: '1102px' }}
            mx="auto"
            autoplay={visible ? true : false}
            displayArrows={true}
            lazyLoadImages={true}
          />
          <Spacer mb="12px" />
        </>
      )}
    </Box>
  )
}

export default WaysToUseCarouselSection
